export default {

  SEND_MAIL (state, data) {
  }
}
